import { extend } from "vee-validate";
import { CPFValidator, CNPJValidator } from ".";

const moment = require("moment");

extend("nomeCompleto", (value) => {
  let array = value.trim().split(" ");
  if (array.length >= 2) {
    return true;
  }
  return "Deve informar  o nome e sobrenome.";
});

extend("docValidator", (value) => {
  const valueWithouMask = value.replace(/\D/g, "");
  if (valueWithouMask.length == 11) {
    if (!CPFValidator.validate(value)) {
      return "O CPF informado é inválido.";
    }
  } else if (valueWithouMask.length == 14) {
    if (!CNPJValidator.validate(value)) {
      return "O CNPJ informado é inválido.";
    }
  }
  return true;
});

extend("cpfValido", (value) => {
  if (CPFValidator.validate(value)) {
    return true;
  }
  return "O {_field_} informado é inválido";
});

extend("cnpjValido", (value) => {
  if (CNPJValidator.validate(value)) {
    return true;
  }
  return "O {_field_} informado é inválido";
});

extend("cpfCnpjValido", (value) => {
  value = value.replace(/[^\d]/g, "");
  if (value.length <= 11) {
    if (CPFValidator.validate(value)) {
      return true;
    }
    return "O CPF informado é inválido";
  } else {
    if (CNPJValidator.validate(value)) {
      return true;
    }
    return "O CNPJ informado é inválido";
  }
});

extend("telefone", {
  validate: (value) => {
    return value.length > 13;
  },
  message: (field) => `${field} inválido`,
});

extend("isPositivo", {
  validate: (value) => {
    return new Number(value) >= 0;
  },
  message: (field) => `Campo ${field} não aceita valores negativos`,
});

extend("cep", {
  validate: (value) => {
    return value.length == 9;
  },
  message: (field) => `${field} inválido`,
});

// valida periodo relatório
extend("dataInicio", (value: any) => {
  let data = new Date(value);
  const ano = data.getFullYear();
  return ano > 1900;
});

// valida periodo relatório
extend("dataFim", (value, args: any) => {
  let dataFim = new Date(value);
  let dataInicio = new Date(args);

  const date = new Date();
  const lastDay: Date = new Date(date.getFullYear(), date.getMonth() + 1, 0);

  if (dataFim < lastDay && dataFim >= dataInicio) {
    return true;
  }
  return "O campo {_field_} ou período informado é inválido";
});

extend("dataMenorQue", (value: any, params) => {
  const args = params as any[];
  if (args[0] != undefined) {
    return moment(value)
      .startOf("day")
      .isBefore(moment(`${args[0]}`).startOf("day"))
      ? "O campo {_field_} não pode ser menor que a Data de"
      : true;
  } else {
    return true;
  }
});

extend("horarioMenorQue", (value: any, params) => {
  const args = params as any[];
  if (args[0] != undefined) {
    return Date.parse(`01/01/2011 ${value}`) <
      Date.parse(`01/01/2011 ${args[0]}`)
      ? "O campo {_field_} não pode ser menor que o horário inicial"
      : true;
  } else {
    return true;
  }
});

extend("dataMaiorQueAtual", (value) => {
  const data = new Date(value);
  return data <= new Date()
    ? true
    : "O campo {_field_} não pode ser maior que a data atual";
});

extend("horarioValido", (value) => {
  return value.match(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)
    ? true
    : "O campo {_field_} não é um horário válido";
});

extend("intervaloMaiorQue", {
  params: ["dataInicial", "quantidadeDias"],
  // @ts-ignore
  validate(value, { dataInicial, quantidadeDias }) {
    if (!dataInicial) {
      return true;
    }
    if (moment(value).diff(moment(dataInicial), "days") > quantidadeDias) {
      return `O intervalo não pode ser maior que ${quantidadeDias} dias`;
    } else {
      return true;
    }
  },
});

extend("percentual", {
  validate: value => {
    return Number(value) <= 100 && Number(value) > 0 ;
  },
  message: field => `${field} inválida`
});

extend("descontoMaiorQue", (value: any, params) => {
  const args = params as any[];
  if (args.length > 1) {
    return value > args[0]
      ? `O campo {_field_} não pode ser maior que o ${args[1]}`
      : true;
  } else {
    return true;
  }
});

extend("senha", (value: any) => {
  let validNumero = /[0-9]/g; // minimo 1 numero
  let validCaracter = "(?=.*?[#?!@$%^&*-])"; // minimo 1 caracter especial

  if (value.match(validNumero) && value.match(validCaracter)) {
    return true;
  }
  return "{_field_} inválida";
});

extend("hora", {
  validate: (value) => {
    const horaValida = value && value.split(":")[0] ? Number(value.split(":")[0]) < 24 : false;
    const minutoValida = value && value.split(":")[1] ? Number(value.split(":")[1]) < 60 : false;

    return horaValida && minutoValida;
  },
  message: (field) => `${field} inválido`,
});

extend("valorMonetarioObrigatorio", {
  validate: (value: string) => {
    let data = value;
    if(data) {
      data = data.replace(/\./g, "").replace(/,/g, ".");
    }
    return new Number(data) >= 0.01;
  },
  message: (field) => `Campo ${field} deve ser maior que 0,00`,
});

extend("not_blank", {
  validate: (value: string) => {
    let data = value;
    if(data) {
      return data.trim().length > 0;
    }
    return true;
  },
  message: (field) => `Campo ${field} deve ser maior que 0,00`,
});

extend("dataHoraMenorQueAtual", {
  params: ['dataAgendamento'],
  validate: (value:string, args: any) => {
    if(!args.dataAgendamento) {
      return true;
    }

    if(args.dataAgendamento == moment().format("YYYY-MM-DD")) {
      const dataHoraInformada = moment(`${args.dataAgendamento} ${value}`, "YYYY-MM-DD HH:mm");
      const dataHoraAtual = moment();
      return dataHoraAtual.isBefore(dataHoraInformada)

    }
    return true;
  },
  message: (field) => `O campo ${field} não pode ser anterior à atual`,
});


extend("valorMonetarioMenor", {
  params: ['valor'],
  validate: (value: string, args: any) => {
    if(!args.valor || !value) {
      return true;
    }

    const intPart = value.split(",")[0].replace(/\D/g, "");
    const decimalPart = value.split(",")[1];

    const valor = Number(`${intPart}.${decimalPart}`);
    const valorComparacao = Number(args.valor);

    return valorComparacao >= valor || `O valor deve ser menor que ${(valorComparacao).toLocaleString("pt-BR", {style: "currency", currency: "BRL"})}`;
  },
});


extend("valorMonetarioMaior", {
  params: ['valor'],
  validate: (value: string, args: any) => {
    if(!args.valor || !value) {
      return true;
    }

    const valor = Number(value);
    const valorComparacao = Number(args.valor);

    return valorComparacao <= valor || `O valor deve ser maior que ${(valorComparacao).toLocaleString("pt-BR", {style: "currency", currency: "BRL"})}`;
  },
});